import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { StyledClearSpan } from '../DatePicker.styled';

export const yearNavigatorTemplate = (e, setSelecterYear, handleClearSelectedDate, t, yearDDRef, onYearChange) => {
    setSelecterYear(e.value);
    return (
        <span>
            <Dropdown
                value={e.value}
                options={e.options}
                onChange={(event) => {
                    if (onYearChange) {
                        onYearChange(event.value);
                    } else {
                        e.onChange(event.originalEvent, event.value);
                    }
                }}
                id="yearDD"
                appendTo={'self'}
                style={{ lineHeight: 1 }}
                ref={yearDDRef}
            />
            <StyledClearSpan onClick={handleClearSelectedDate}>
                {t('common.clearButton')}
            </StyledClearSpan>
        </span>
    );
};
